import { FC } from 'react'

type ChooseOrganizationViewProps = {}

export const ChooseOrganizationView: FC<ChooseOrganizationViewProps> = () => {
	return null
}